import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import UniformList from '../uniformList/index';
import UniformDetail from '../uniformDetail/index';
import { UniformProvider } from '../context/uniformContext';
import AssignUniform from '../assignUniform';
import AllocatedUniform from '../uniformAllocations';
import UniformStock from '../uniformStock/index';

function UniformRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"UNIFORMS HEREEEEEEEEEEEEE")

  return (
    <UniformProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>   
       <Route index element={<UniformList />} />      {/*  Matches `/uniforms` */}
       <Route path=":id" element={<UniformDetail />} />  {/* Matches `/uniforms/:id` */}
       <Route path="/assign-uniform" element={<AssignUniform />} /> 
       <Route path="/uniform-allocations" element={<AllocatedUniform />} /> 
       <Route path="/uniform-stock" element={<UniformStock />} />

      </Route>
    </Routes>
    </UniformProvider>
  );
}

export default UniformRouter;
